import { LucideIcon  } from 'lucide-react';
import {  useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";

interface Icard {
    title: string,
    text: string,
    icon: LucideIcon,
    iconBgColor: string,
    iconColor: string
}

// {title, describe, nameButton,icon:Icon}:Icardservices

export const CardServices = ({title, icon:Icon, text, iconBgColor, iconColor}:Icard) => {


  //Criando variavel
  const cardCentralServices = useRef<HTMLDivElement | null>(null)

  //Renderizando os cards
  useEffect(() => {

    //abreviando a sigla 
    const sr = ScrollReveal()

    //Condição para a animação
    if(cardCentralServices.current) {
      sr.reveal(cardCentralServices.current, {
        duration: 1500,
        distance:'100px',
        origin: 'bottom',
        easing:'ease-in-out',
        reset: false
      })
    }

     //para não evitar conflito
      return () => sr.destroy();
  },[])


    return(
        <div  className="flex p-2 mt-10">

      <article 
      ref={cardCentralServices}
      className='md:flex  md:justify-between'>
          <div className='group md:hover:border border-red-600 flex flex-col md:w-[30vw] gap-y-4  w-[80vw] md:h-[34vh] bg-black p-4  items-start rounded-md text-start '>
            
            <span className={`${iconBgColor} p-1 rounded-md group-hover:bg-red-600`}>
              <p className={`${iconColor} group-hover:text-red-900`}><Icon /></p>
            </span>

              <p className='text-text-2xl font-bold text-white fontTitle group-hover:text-red-600'>{title}</p>
              <p className='text-sm text-gray-400 fontText '>{text}</p>
          </div>
      </article>

      
    </div>
    )
}